var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "4.9 6.2 4.9 25.6 18.9 25.6",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3,
    cy: 22.4,
    r: 5.8,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,19.7c1.5-1.3,3.8-1.1,5.1.4",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,25.6h3.3v8.4c0,.7-.5,1.2-1.2,1.2h-.9c-.7,0-1.2-.5-1.2-1.2v-8.4h0Z",
    transform: "translate(-12.3 27.8) rotate(-40.8)",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.7,
    y1: 30,
    x2: 31.3,
    y2: 27.8,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "20.4 6.6 25.2 6.8 16.4 14.8 15 22.4 10.8 20.4 7.6 22.7",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.4,
    y1: 11.5,
    x2: 25.4,
    y2: 6.8,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingIcon);
export default __webpack_public_path__ + "static/media/marketing-icon.23b871f6e0c9595bc0ab4b6da28bb669.svg";
export { ForwardRef as ReactComponent };